import { useState, useMemo } from "react"

export default <T,>(key: string) => {
	const [sessionValue, setSessionValue] = useState<string | null>(
		typeof window !== "undefined" ? window.sessionStorage.getItem(key) : null
	)

	const value = useMemo<T>(
		() => (sessionValue && sessionValue !== "undefined" ? JSON.parse(sessionValue) : undefined),
		[sessionValue]
	)

	const setValue = (val: T) => {
		if (val === undefined || val === null) {
			window.sessionStorage.removeItem(key)
			setSessionValue(null)
		} else {
			const encodedValue = JSON.stringify(val)
			window.sessionStorage.setItem(key, encodedValue)
			setSessionValue(encodedValue)
		}
	}

	return [value, setValue] as const
}
